const { makeStyles } = require('@material-ui/core');

export const useStyles = makeStyles({
  container: {
    position: 'relative',
  },
  floatingContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 4,
    top: 6,
    left: 6,
    right: 6,
    height: 32,
  },
  floatingContainerWrapper: {
    display: 'flex',
    gap: 4,
  },
});
